import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { FaSave, FaTimes, FaCalendarAlt } from "react-icons/fa";

const ModalReglas = ({ show, onHide, regla, estatusOptions, onSave, loading }) => {
    const [form, setForm] = useState({
        Titulo: '',
        Regla: '',
        Porcentaje: '',
        VigenciaInicio: '',
        VigenciaFin: '',
        Estatus: 'Activa'
    });

    useEffect(() => {
        if (regla) {
            setForm({
                Titulo: regla.titulo || '',
                Regla: regla.regla || '',
                Porcentaje: regla.porcentaje != null ? regla.porcentaje.toString() : '',
                VigenciaInicio: fechaInputValue(regla.vigenciaInicio),
                VigenciaFin: fechaInputValue(regla.vigenciaFin),
                Estatus: regla.estatus || 'Activa'
            });
        } else {
            setForm({
                Titulo: '',
                Regla: '',
                Porcentaje: '',
                VigenciaInicio: '',
                VigenciaFin: '',
                Estatus: 'Activa'
            });
        }
    }, [regla, show]);

    const fechaInputValue = (d) => {
        if (!d) return '';
        const dt = new Date(d);
        if (isNaN(dt)) return d;
        const yyyy = dt.getFullYear();
        const mm = String(dt.getMonth() + 1).padStart(2, '0');
        const dd = String(dt.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`; // formato para input[type=date]
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        if (!form.Titulo.trim()) return "El título es requerido.";
        if (!form.Regla.trim()) return "La regla es requerida.";
        if (!form.Porcentaje.toString().trim()) return "El porcentaje es requerido.";
        const p = parseFloat(form.Porcentaje);
        if (isNaN(p) || p < 0) return "Porcentaje inválido.";
        if (!form.VigenciaInicio) return "Fecha inicio es requerida.";
        if (!form.VigenciaFin) return "Fecha fin es requerida.";
        if (new Date(form.VigenciaInicio) > new Date(form.VigenciaFin)) return "La vigencia inicio no puede ser mayor a la vigencia fin.";
        return null;
    };

    const handleSubmit = async () => {
        const err = validate();
        if (err) {
            window.Swal?.fire?.({
                position: "top-end",
                icon: "warning",
                title: err,
                showConfirmButton: false,
                timer: 1800,
                customClass: { popup: 'nova-swal-popup' }
            });
            return;
        }

        // Envía al padre
        await onSave({
            ...form
        });
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{regla ? 'Editar Regla' : 'Nueva Regla'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Título</Form.Label>
                        <Form.Control
                            type="text"
                            name="Titulo"
                            value={form.Titulo}
                            onChange={handleChange}
                            placeholder="Nombre de la regla (ej. Regla navidad 2025)"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Regla (condiciones)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="Regla"
                            value={form.Regla}
                            onChange={handleChange}
                            placeholder="Ej. Segmento=Mayoristas y Region=Norte"
                        />
                        <Form.Text className="text-muted">Puedes escribir varias líneas para representar condiciones.</Form.Text>
                    </Form.Group>

                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <Form.Group>
                                <Form.Label>Porcentaje (%)</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    name="Porcentaje"
                                    value={form.Porcentaje}
                                    onChange={handleChange}
                                    placeholder="5.5"
                                />
                                <Form.Text className="text-muted">Ejemplo: 5.5 (sin el símbolo %)</Form.Text>
                            </Form.Group>
                        </div>

                        <div className="col-md-4 mb-3">
                            <Form.Group>
                                <Form.Label>Vigencia Inicio</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="VigenciaInicio"
                                    value={form.VigenciaInicio}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-4 mb-3">
                            <Form.Group>
                                <Form.Label>Vigencia Fin</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="VigenciaFin"
                                    value={form.VigenciaFin}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div>
                    </div>

                    <Form.Group className="mb-3">
                        <Form.Label>Estatus</Form.Label>
                        <Form.Select name="Estatus" value={form.Estatus} onChange={handleChange}>
                            {estatusOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={loading}>
                    <FaTimes className="me-1" /> Cancelar
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            <span className="ms-2">Guardando...</span>
                        </>
                    ) : (
                        <>
                            <FaSave className="me-1" /> Guardar
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalReglas;
